import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { configure_getting_started_progress, configure_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as Collection } from "../../../assets/svg/collection.svg";
import { dispatch } from "d3";
import { setActiveModule } from "../../../actions/sideBarActions";

const Collections = () => {
    const dispatch = useDispatch();
    const packageObj = useSelector((state) => state.globalReducer.packageObj);
    useEffect(() => {
        if (packageObj?.package_code !== "enterprise") {
            let obj = {
                // total_sections: 33,
                progress_config: {
                    explore_collections: 1,
                },
            };
            dispatch(configure_getting_started_progress(obj));
        }
    }, []);

    const configureProgress = () => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                explore_collections: 1,
            },
        };
        localStorage.setItem("activeModule", "Listening");
        dispatch(setActiveModule("Listening"));
        dispatch(configure_getting_started_progress(obj));
    };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <Collection className="icon_content fill_svg" />

                        <span className="content_title">Collections</span>
                    </div>
                    <div className="text_content">
                        <p>{`Collections are like a folder where you can add posts of similar type or set up an alert to automatically add posts to the collection.`}</p>
                        <p>Collections can be kept private to you or shared with teams.</p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    {packageObj?.package_code === "enterprise" ? (
                        <Link to="/collections">
                            <button className="gs_link" onClick={() => configureProgress()}>
                                Explore
                            </button>
                        </Link>
                    ) : (
                        <div className="no__access__info">*Available in Enterprise package only</div>
                    )}
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/JoLO2EihBf8"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default Collections;
